//modalDrrawer.js
import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import ExecutePlanner from "../../features/planner/modal/executePlanner";
import EditMember from "../../features/member/modal/editMember";
import Attendance from "../../features/member/modal/attendance";
import BookAppointment from "../../features/appointment/modals/trainer-book-appointment";
import MarkAppointmentReport from "../../features/appointment/modals/markAppointmentReport";
import RescheduleAppointment from "../../features/appointment/modals/reschedule-appointment";
import AppointmentInfo from "../../features/appointment/modals/appointment-info";
import ManageEnquiry from "../../features/enquiry/modals/manage-enquiry";
import MemberSlotBooking from "../../features/slot-booking/member";
import FitnessTest from "../../features/member/modal/fitnessTest";
import PlannerExerciseView from "../../features/planner/modal/plannerExerciseVIew";
import ScheduleFollowup from "../../features/enquiry/modals/schedule-followup";
import MembershipBillingController from "../membershipBilling";
import FollowUpResponse from "../../features/follow-up/modal/follow-up-response";
import FollowUpHistory from "../../features/follow-up/modal/history"; 
import AddOnDays from "../../features/memberships/modals/add-on-days";
import DateChange from "../../features/memberships/modals/date-change";
import ChangeInvoice from "../../features/payments/Models/change-invoice";
import ChangePaymentDate from "../../features/payments/Models/change-payment-date";
import BulkReassign from "../../features/follow-up/modal/bulk-reassign";
import { MembershipOfferForm } from "../../features/salesKiosk/components/membershipOfferForm"; 
import ManageMembership from "../../features/membership-plans/modals/manageMembership"; 
import ManageEmployee from "../../features/employees/modals/manage-employee";
import ManageCompany from "../../features/company";
import ManageGymForm from "../modal/desktop/ManageGym";
import ManageGym from "../../features/gyms/modals/manage-gym";
import GymSetting from "../../features/gyms/modals/branchSettings";
import ManageSlack from "../modal/desktop/ManageSlack";
import ManageUserLookup from "../../features/user-lookup/modal/manage-profile";
import ManageWorkoutPlanner from '../modal/desktop/ManageWorkoutPlanner';
import ManageFitnessPlanner from '../modal/desktop/ManageFitnessPlanner';
import PlannerPreview from "../../features/planner/components/planner-preview";
import ContentView from "../../features/content/modal/ContentView"; 
import BalancePaymentModal from "../../features/member/modal/balancePayment";
import ConvertToMember from "../../features/enquiry/modals/convert-to-member";
import EditMembershipModal from "../../features/member/modal/editMembership";
import TransferMembershipModal from "../../features/member/modal/transferMembership";
import FreezeMembershipModal from "../../features/member/modal/freezeMembership";
import DeleteMembershipModal from "../../features/member/modal/deleteMembership";
const ModalDrawer = (props) => {

  const [translateY, setTranslateY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startYRef = useRef(0);
    
    

  const handleTouchStart = (e) => {
    document.body.style.overflow = 'hidden';
    setIsDragging(true);
    startYRef.current = e.touches[0].clientY;
  };

  const handleTouchMove = (e) => {
    document.body.style.overflow = 'hidden';
    
    if (!isDragging) return;
    const currentY = e.touches[0].clientY;
    const diff = currentY - startYRef.current;

    
    if (diff > 0) e.preventDefault();

    
    setTranslateY((prev) => {
      const newTranslateY = Math.min(Math.max(prev + (diff * 2.2 / window.innerHeight) * 70, 0), 100);

      
      const rotationAngle = Math.min(Math.max((1 - (newTranslateY / 100)) * 45, 0), 45);
  
      
      const startColor = [227, 58, 52]; // RGB of #055075
      const endColor = [5, 80, 117];   // RGB of #055075
      const interpolatedColor = startColor.map((start, i) => 
        Math.round(start + ((endColor[i] - start) * (newTranslateY / 100)))
      );
      const bgColor = `rgb(${interpolatedColor.join(',')})`;

      
      const svgElement = document.querySelector('.rotatable-icon');
      if (svgElement) {
        svgElement.style.transform = `rotate(${rotationAngle}deg)`;
      }

     
      const targetContainer = document.querySelector('.add-button');
      if (targetContainer) {
        targetContainer.style.backgroundColor = bgColor;
      }


      return newTranslateY;
    });

    startYRef.current = currentY;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  
    if (translateY > 30) {
      setTranslateY(100);
      document.body.style.overflow = 'visible';
      
      if(props.modalType == "member-book-schedule"){
        props.handleMemberBookAppointment();
      }

      if(props.modalType == "assign-planner"){
        props.toggleManageExecutePlanner();
      }

      if(props.modalType == "edit-member"){
        props.toggleAddMemberModal();
      }
      if(props.modalType == "edit-company"){
        props.toggleManageCompanyModal();
      }
      if(props.modalType == "member-attendance"){
        props.toggleMemberAttendance();
      }

      if(props.modalType == "book-appointment"){
        props.handleBookAppointment();
      }

      if(props.modalType == "mark-appointment-report"){
        props.handleMarkReport()
      }
      if(props.modalType == "transfer-membership"){
        props.toggleFitnessTestModal();
      }
      if(props.modalType == "reschedule-appointment"){
        props.handleRescheduleAppointment()
      }

      if(props.modalType == "view-appointment"){
        props.handleViewAppointment()
      }

      if(props.modalType == "fitness-test"){
        props.toggleFitnessTestModal()
      }
      if(props.modalType == "edit-membership-plan"){
        props.handleCloseModal();
      }
      if(props.modalType == "edit-membership"){
        props.toggleFitnessTestModal();
      }
      if(props.modalType == "fitness-test-existing"){
        props.toggleFitnessTestModal()
      }
      if(props.modalType == "manage-employee"){
        props.handleCloseModal();
      }
      if(props.modalType == "membership-offer"){
        props.handleCloseModal();
      }
      if(props.modalType == "edit-gymBranch"){
        props.handleEditGymBranch();
      }
      if(props.modalType == "gym-setting"){
        props.handleGymSetting();
      }
      if(props.modalType == "manage-slack"){
        props.handleManageSlack();
      }
      if(props.modalType == "manage-userlookup"){
        props.handleUserLookup();
      } 
      if(props.modalType == "edit-planner"){
        props.handleCloseModal();
      }
      if(props.modalType == "planner-preview"){
        props.handleCloseModal();
      }
      if(props.modalType == "content-view"){
        props.handleCloseModal();
      }
      if(props.modalType == "upgrade-membership"){
        props.toggleFitnessTestModal();
      }
      if(props.modalType == "freeze-membership"){
        props.toggleFitnessTestModal();
      }
      if(props.modalType == "delete-membership"){
        props.toggleFitnessTestModal();
      }
    } else {
      setTranslateY(0);

      document.body.style.overflow = 'hidden';

    }
  };

  const closeDrawer = () => {
    setTranslateY(100);
  }

const closeModal = () => {
  console.log("close tapped", props.modalType, typeof props.handleCloseModal);
  document.body.style.overflow = 'visible';
  if (props.handleCloseModal) props.handleCloseModal();
  else if (props.handleClose) props.handleClose("");
  else if (props.close) props.close();
};
  return ReactDOM.createPortal(
    <div className='d-flex' style={{ position: "fixed", top: 0, left: 0, zIndex: 999998 }}>
      <div className={`overlay ${translateY < 100 ? "active" : ""}`} onClick={closeDrawer} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 999998 }} ></div>
       <div className="drawer" style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, width: "100%", transform: `translateY(${translateY}%)`, height: "100%", zIndex: 999999, paddingBottom: "0", borderRadius: "0px", paddingTop: "80px", }} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} >
        <div className='modal-item-header' style={{zIndex:'0'}}>
          <div className='d-flex w-full' style={{justifyContent:"center"}}>
            <div className='handle'/>
          </div>
          <div className='d-flex w-full space-between m-t-38 p-l-14 p-r-14'>
            <div onClick={(e) => { e.stopPropagation(); closeModal(); }} onTouchStart={(e) => e.stopPropagation()} onTouchMove={(e) => e.stopPropagation()} className='close-modal-item d-flex' >
            {/* <div onClick={()=>{ console.log("X clicked, modalType:", props.modalType, "fn:", typeof props.handleCloseModal); props.handleCloseModal(); }} className='close-modal-item d-flex'> */}
              <svg className='flex-item margin-auto' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.58398 15.8333L15.4173 5M15.4173 15.8333L4.58398 5" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p className='flex-item fs-19 font-weight-700 color-white'>{props.modalHeader}</p>
            <svg width="26" height="26" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.46875 4.6875C8.46875 4.81182 8.41936 4.93105 8.33146 5.01896C8.24355 5.10686 8.12432 5.15625 8 5.15625C7.87568 5.15625 7.75645 5.10686 7.66854 5.01896C7.58064 4.93105 7.53125 4.81182 7.53125 4.6875C7.53125 4.56318 7.58064 4.44395 7.66854 4.35604C7.75645 4.26814 7.87568 4.21875 8 4.21875C8.12432 4.21875 8.24355 4.26814 8.33146 4.35604C8.41936 4.44395 8.46875 4.56318 8.46875 4.6875ZM8 6.5625C8.09324 6.5625 8.18266 6.59954 8.24859 6.66547C8.31452 6.7314 8.35156 6.82082 8.35156 6.91406V10.4297C8.35156 10.5229 8.31452 10.6123 8.24859 10.6783C8.18266 10.7442 8.09324 10.7812 8 10.7812C7.90676 10.7812 7.81734 10.7442 7.75141 10.6783C7.68548 10.6123 7.64844 10.5229 7.64844 10.4297V6.91406C7.64844 6.82082 7.68548 6.7314 7.75141 6.66547C7.81734 6.59954 7.90676 6.5625 8 6.5625Z" fill="#B5EBFF"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 7.5C15.5 11.6438 12.1438 15 8 15C3.85625 15 0.5 11.6438 0.5 7.5C0.5 3.35625 3.85625 0 8 0C12.1438 0 15.5 3.35625 15.5 7.5ZM15.0312 7.5C15.0312 11.3812 11.8812 14.5312 8 14.5312C4.11875 14.5312 0.96875 11.3812 0.96875 7.5C0.96875 3.61875 4.11875 0.46875 8 0.46875C11.8812 0.46875 15.0312 3.61875 15.0312 7.5Z" fill="#B5EBFF"/>
            </svg>
          </div>
        </div>
        <div onTouchStart={(e)=>e.stopPropagation()} className="w-full h-full" style={{borderRadius:"12px 12px 0 0", zIndex:"1"}}>
          <div className="modal-container d-flex flex-item">
            {
              props.modalType == "member-book-schedule" && (
                <MemberSlotBooking handleCloseModal={props.handleMemberBookAppointment} selectedUserApt={props.selectedUserApt} handleApiAction={props.handleApiAction}/>
              )
            }

            {
              props.modalType == "book-appointment" && (
                <BookAppointment/>
              )
            }

            {
              props.modalType == "mark-appointment-report" && (
                <MarkAppointmentReport appointmentDetails={props.appointmentDetails} updateCalendarSlot={props.updateCalendarSlot} handleCloseModal={props.handleCloseReportModal} handleCloseReportModal={props.handleCloseReportModal} />
              )
            }

            {
              props.modalType == "reschedule-appointment" && (
                <RescheduleAppointment appointmentDetails={props.appointmentDetails} />
              )
            }
            {
            props.modalType == "edit-membership-plan" && (
              <ManageMembership reload={props.reload} membershipPlan={props.membershipPlan} handleCloseModal={props.handleCloseModal} />
            )
            }
            {
              props.modalType == "edit-membership" && (
                <EditMembershipModal toggleFitnessTestModal={props.toggleFitnessTestModal} membership={props.membership} reload={props.reload} />
              )
            }
            {
             props.modalType == "edit-company" && ( <ManageGymForm isEdit={true} gym={{ ...props.company }} reload={props.reload} toggleAddGymModal={props.handleCloseModal}/>
            )
            }
            {
              props.modalType == "view-appointment" && (
                <AppointmentInfo appointmentDetails={props.appointmentDetails} handleCloseModal={props.handleCloseModal} />
              )
            }

            {
              props.modalType == "assign-planner" && (
                <ExecutePlanner PlannerType={props.PlannerType} members={props.members}/>
              ) 
            }

            {
              props.modalType == "edit-member" && (
                <EditMember member={props.member} handleCloseModal={props.handleCloseModal} />
              )
            }

            {
              props.modalType == "member-attendance" && (
                <Attendance member={props.member} type={props.type} closeMemberAttendance={props.toggleMemberAttendance} />
              )
            }
            {
              props.modalType == "upgrade-membership" && (
                <MembershipBillingController type="upgrade-membership" reload={props.reload} selectedUsers={props.membership} handleCloseModal={props.toggleFitnessTestModal} handleCreatedMembershipId={props.handleCreatedMembershipId} />
              )
            }

            {
              props.modalType == "freeze-membership" && (
                <FreezeMembershipModal toggleFitnessTestModal={props.toggleFitnessTestModal} membership={props.membership} reload={props.reload} />
              )
            }

            {
              props.modalType == "delete-membership" && (
                <DeleteMembershipModal reload={props.reload} membership={props.membership} packageMemberships={props.packageMemberships} toggleFitnessTestModal={props.toggleFitnessTestModal} />
              )
            }

            {
              props.modalType == "manage-enquiry" && (
                <ManageEnquiry type={props.type} phoneNo={props.phoneNo} selectedUsers={props.selectedUsers} reload={props.reload} reloadEnquiry={props.reloadEnquiry} handleCloseModal={props.handleCloseModal} handleNewSale={props.handleNewSale} />
              )
            }

            {/* {
              props.modalType == "schedule-followup" && (
                <ScheduleFollowup selectedUsers={props.selectedUsers} gym={props.selectedGym} handleCloseModal={props.handleCloseModal}/>
              )
            } */}
            {
              props.modalType == "schedule-followup" && (
                <ScheduleFollowup followUpType={props.followUpType} selectedUsers={props.selectedUsers} gym={props.gym} handleCloseModal={props.handleCloseModal} />
              )
            }
            {
              props.modalType == "followup-response" && (
                <FollowUpResponse handleClose={props.handleClose} selectedGym={props.selectedGym} followup={props.followup} closeAndReload={props.closeAndReload} />
              )
            }

            {
              props.modalType == "followup-history" && (
                <FollowUpHistory close={props.close} closeAndReload={props.closeAndReload} followup={props.followup}/>
              )
            }

            {
              props.modalType == "close-enquiry" && (
                <MembershipBillingController type={props.type} reload={props.reload} selectedUsers={props.selectedUsers} handleCloseModal={props.handleCloseModal} handleCreatedMembershipId={props.handleCreatedMembershipId} />
              )
            }
            {
              props.modalType == "transfer-membership" && (
                <TransferMembershipModal toggleFitnessTestModal={props.toggleFitnessTestModal} membership={props.membership} reload={props.reload} />
              )
            }
            {
              props.modalType == "fitness-test" && (
                <FitnessTest memberInfo={props.memberInfo} toggleFitnessTestModal={props.toggleFitnessTestModal} actionType={props.actionType} />
              )
            }
            {
              props.modalType == "convert-to-member" && (
                <ConvertToMember selectedUsers={props.selectedUsers} handleCloseModal={props.handleCloseModal} />
              )
            }
            {
              props.modalType == "fitness-test-existing" && (
                <FitnessTest memberInfo={props.memberInfo} parentReport={props.parentReport} latestChildReport={props.latestChildReport} toggleFitnessTestModal={props.toggleFitnessTestModal} />
              )
            }

            {
              props.modalType == "add-on-days" && (
                <AddOnDays toggleModal={props.toggleModal} membership={props.membership} reload={props.reload} />
              )
            }

            {
              props.modalType == "start-date" && (
                <DateChange toggleModalType={props.toggleModalType} membership={props.membership} reload={props.reload} />
              )
            }

            {
              props.modalType == "change-invoice-date" && (
                <ChangeInvoice handleCloseModal={props.handleCloseModal} payment={props.payment} reload={props.reload} />
              )
            }

            {
              props.modalType == "change-payment-date" && (
                <ChangePaymentDate handleCloseModal={props.handleCloseModal} payment={props.payment} reload={props.reload} />
              )
            }

            {
              props.modalType == "planner-content-view" && (
                <PlannerExerciseView contentInfo={props.contentInfo} />
              )
            }

            {
              props.modalType == "bulk-reassign" && (
                <BulkReassign handleClose={props.handleClose} followups={props.followups} followup={props.followup} isBulkAction={props.isBulkAction} selectedGym={props.selectedGym} closeAndReload={props.closeAndReload}/>
              )
            }

            {
              props.modalType == "membership-offer" && ( <MembershipOfferForm initialData={props.initialData} onClose={props.handleCloseModal} onSave={props.onSave} hideHeader /> )
            }
            { 
            props.modalType == "manage-employee" && ( <ManageEmployee isEdit={props.isEdit} user={props.user} isUserLookup={props.isUserLookup} toggleAddUserModal={props.handleCloseModal} /> )
            }
            {
            props.modalType == "edit-gymBranch" && ( <ManageGym branch={{...props.branch}} isEditEnabled={true} toggleAddBranchModal={props.handleCloseModal} handleReloadGyms={props.handleReloadGyms} type="edit" />
             )
            }
            {
            props.modalType == "gym-setting" && ( <GymSetting toggleBranchSettings={props.handleCloseModal} branch={props.branch} hideHeader />
             )
            }
            {
             props.modalType == "manage-slack" && ( <ManageSlack handleManageSlackModal={props.handleCloseModal} branchId={props.branchId} branch={props.branch} hideHeader />
              )
            }
            {
            props.modalType == "manage-userlookup" && ( <ManageUserLookup user={props.user} toggleWorkoutPlanner={props.handleCloseModal} getUsers={props.getUsers} />
            ) 
            }
            {
              props.modalType == "edit-planner" && (
                props.plannerType == "nutrition" ? (
                  <ManageWorkoutPlanner isEdit={true} nutritionPlanner={props.planner} workoutPlanner="" toggleAddWorkoutPlanner={props.handleCloseModal} hideHeader />
                ) : props.plannerType == "fitness" ? (
                  <ManageFitnessPlanner isEdit={true} fitnessPlanner={props.planner} toggleAddFitnessPlanner={props.handleCloseModal} hideHeader />
                ) : (
                  <ManageWorkoutPlanner isEdit={true} workoutPlanner={props.planner} nutritionPlanner="" toggleAddWorkoutPlanner={props.handleCloseModal} hideHeader />
                )
              )
            }
            {
              props.modalType == "planner-preview" && ( <PlannerPreview selectedPlannerInfo={props.selectedPlannerInfo} togglePlannerPreview={props.handleCloseModal} hideHeader />
              )
            }
            {
            props.modalType == "content-view" && ( <ContentView selectedContentId={props.contentId} />
              )
            }
            {
              props.modalType == "pay-balance" && ( <BalancePaymentModal togglePaymentModal={props.handleCloseModal} paymentId={props.paymentId} reload={props.reload} />
              )
            }
          </div>
        </div>
      </div>
    </div>,document.body
  )
}

export default ModalDrawer;